<img *ngIf="alternativa" [src]="alternativa.alternativa" />
<p *ngIf="!alternativa">-</p>
